import { render, staticRenderFns } from "./MattressDetails.vue?vue&type=template&id=21fa20c6"
import script from "./MattressDetails.vue?vue&type=script&lang=js"
export * from "./MattressDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports